import {
  BoldItalicUnderlineToggles,
  headingsPlugin,
  linkPlugin,
  listsPlugin,
  ListsToggle,
  markdownShortcutPlugin,
  MDXEditor,
  quotePlugin,
  Separator,
  tablePlugin,
  thematicBreakPlugin,
  toolbarPlugin,
  UndoRedo,
} from '@mdxeditor/editor'
import { clsx } from 'clsx'

export interface MarkdownEditorProps {
  onChange?: (markdown: string) => void
  markdown: string
}

export default function MarkdownEditor({
  onChange,
  markdown,
}: MarkdownEditorProps) {
  return (
    <MDXEditor
      className="dark-theme"
      onChange={onChange}
      markdown={markdown}
      contentEditableClassName={clsx(
        'markdown-editor',
        'border-input focus-visible:border-primary hover:border-primary rounded-xl border bg-white/3 p-3 transition-[color] mt-2',
      )}
      plugins={[
        headingsPlugin(),
        listsPlugin(),
        linkPlugin(),
        quotePlugin(),
        thematicBreakPlugin(),
        tablePlugin(),
        markdownShortcutPlugin(),
        toolbarPlugin({
          toolbarContents: () => (
            <>
              <UndoRedo />
              <Separator />
              <BoldItalicUnderlineToggles />
              <Separator />
              <ListsToggle />
              <Separator />
            </>
          ),
        }),
      ]}
    />
  )
}
